<style lang="scss" scoped>
.news {
    h3 {
        letter-spacing: -1.16px;
    }
    .item {
        border-radius: 20px;
        position: relative;
        height: 220px;
        @media (min-width: 1024px) {
            height: 300px;
        }
        img {
            border-radius: 20px;
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
        .overlay {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 20px;
            background: linear-gradient(194.95deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.48) 100%);
        }
        .content {
            padding: 16px;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 20px;
            display: flex;
            flex-flow: column-reverse;
            @media (min-width: 1024px) {
                padding: 24px;
            }
            @media (min-width: 1136px) {
                padding: 32px;
            }
        }
        .card-title {
            color: #ffffff;
            font-weight: 800;
            letter-spacing: -1.16px;
            word-break: break-word;
        }
        .tag {
            border-radius: 4px;
            background-color: #f95950;
            padding: 4px 8px;
            text-transform: uppercase;
            display: inline-block;
            color: #ffffff;
            font-family: Rubik;
            font-size: 12px;
            letter-spacing: 0.01px;
            line-height: 15px;
            margin-right: auto;
        }
    }
}
</style>

<template>
    <section class="news container">
        <h3 v-animate.fade="'slide-up'" class="text-24 text-white lg:text-center font-extraBold lg:text-title-md mb-30 lg:mb-60" v-html="data.title"></h3>
        <div v-animate.fade="'slide-up'" delay="1" class="grid gap-20 lg:gap-40 grid-cols-2 md:grid-cols-3 mb-60">
            <a v-if="locale === 'nl'" :href="`/blog/${item.slug}`" v-for="item in news" :key="item.id" class="item col-span-2 md:col-span-1">
                <img :data-src="item.acf.image.url" :alt="item.acf.image.alt" class="lazyload" />
                <div class="overlay"></div>
                <div class="content">
                    <h4 class="card-title text-24 md:text-20">{{ item.title.rendered }}</h4>
                    <div class="tag mb-16">Info</div>
                </div>
            </a>
            <a v-if="locale !== 'nl'" :href="`/${locale}/blog/${item.slug}`" v-for="item in news" :key="item.id" class="item col-span-2 md:col-span-1">
                <img :data-src="item.acf.image.url" :alt="item.acf.image.alt" class="lazyload" />
                <div class="overlay"></div>
                <div class="content">
                    <h4 class="card-title text-24 md:text-20" v-html="item.title.rendered"></h4>
                    <div class="tag mb-16">Info</div>
                </div>
            </a>
        </div>
        <div v-if="data.can_load_more" class="container flex justify-center">
            <a v-if="locale === 'nl'" href="/blog" class="text-button text-dark rounded-button border border-white bg-white font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-white">
                Nog meer info over stoppen met roken
            </a>
            <a v-if="locale === 'fr'" href="/fr/blog" class="text-button text-dark rounded-button border border-white bg-white font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-white">
                Plus d'informations sur l'arrêt du tabac
            </a>
            <a v-if="locale === 'en'" href="/en/blog" class="text-button text-dark rounded-button border border-white bg-white font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-white">
                More info on quitting smoking
            </a>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        },
        locale:{
            required: false,
            default: 'nl'
        }
    },

    data: () => ({
        news: []
    }),

    mounted() {
        this.getLatestNews();
    },

    methods: {
        getLatestNews() {
            axios
                .get("/api/news", {
                    params: {
                        perPage: 10,
                        locale: this.locale
                    }
                })
                .then(response => {
                    if(this.data.random){
                        this.news = response.data.data.sort(function() {return 0.5 - Math.random()}).slice(0, this.data.limit);
                    } else {
                        this.news = response.data.data;
                    }
                });
        }
    }
};
</script>
